import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppBreadCrumb from '../../common/AppBreadCrumb'
import AppToaster from '../../AppToaster';
import { createTag, fetchTag, updateTag } from '../../../api/TagsAPI';
import { handleApiError } from '../../../api/risapi';

const TagsForm = ({ formType, currentTagId }) => {
    const navigate = useNavigate();
    const [tag, setTag] = useState({ name: '' });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (formType === 'edit' && currentTagId) {
            fetchTag(currentTagId, (response) => {
                if (response.tag) {
                    setTag(response.tag);
                }
            });
        } else {
            // Reset form for 'create' mode
            setTag({ name: '' });
        }
    }, [formType, currentTagId]);

    const getTitle = () => formType === 'create' ? 'Create New Tag' : 'Edit Tag';

    const handleSave = (e) => {
        e.preventDefault();
        const apiCall = formType === 'create' ? createTag : updateTag;

        apiCall(tag, (response) => {
            if (response.tag) {
                navigate('/docs/tags', { state: { message: `Tag ${formType === 'create' ? 'created' : 'updated'} successfully!` } });
            } else {
                handleApiError(response, setErrors);
            }
        });
    };

    return (
        <main>
            <div className="container-fluid">
                <AppBreadCrumb title={getTitle()}>
                    <li><a className="f-s-14 f-w-500" href="#">Docs Master</a></li>
                    <li><a className="f-s-14 f-w-500" href="/docs/tags">Tags</a></li>
                    <li className="active"><a className="f-s-14 f-w-500" href="#">{formType === 'create' ? 'Create' : 'Edit'}</a></li>
                </AppBreadCrumb>

                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h5>{getTitle()} {formType === 'edit' && tag ? `: ${tag.name}` : ''}</h5>
                            </div>
                            <div className="card-body">
                                <form className="app-form" onSubmit={handleSave}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label className="form-label">Tag Name *</label>
                                                <input
                                                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                    placeholder="Enter Tag Name"
                                                    value={tag ? tag.name : ''}
                                                    onChange={(e) => setTag({ ...tag, name: e.target.value })}
                                                    required
                                                    type="text"
                                                />
                                                {errors.name && <div className="invalid-feedback">{errors.name[0]}</div>}
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="text-end">
                                                <button className="btn btn-primary me-2" type="submit">
                                                    {formType === 'create' ? 'Save' : 'Update'}
                                                </button>
                                                <button className="btn btn-danger" type="button" onClick={() => navigate('/docs/tags')}>
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default TagsForm;

